import { InjectionToken } from "@angular/core";

declare let window: any;

export const LD_ENV_KEY = new InjectionToken<string>("LD_ENV_KEY");

export function ldEnvKeyFactory(): string {
  return window.__env.launchDarklyKey;
}
